
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import * as toastr from "toastr";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import NumericId from "@/vue/components/NumericId.vue";
    import ConfirmDialogue from "@/vue/components/ConfirmDialogue.vue";
    import DatePicker from "@/vue/components/DatePicker.vue";
    import { ISaveResponse } from "@/model/ISaveResponse";
    import { IBriefing, Briefing } from "@/model/Briefing";
    import { ISiteLookup } from "@/model/Site";
    import { ILookupItem } from "@/model/LookupItem";
    import { IClientLookup } from "@/model/Client";

    @Component({ components: { ApiButton, NumericId, ConfirmDialogue, DatePicker } })
    export default class BriefingDialogue extends Vue {

        // async mounted(): Promise<void> {
        //     await Promise.all([
        //         (async () => { this.clientList = await ApiClient.get("/api/client/lookups"); })(),
        //         (async () => { this.siteList = await ApiClient.get("/api/site/lookups"); })(),
        //     ]);
        // }

        //
        // -- properties
        //

        @Ref("briefingForm") private readonly briefingForm!: VForm;

        @Prop({ required: true })
        clientList!: Array<IClientLookup>;
        get clientOptions(): Array<IClientLookup> { return Utils.clientOptionsFilter(this.clientList); }

        @Prop({ required: true })
        siteList!: Array<ISiteLookup>;
        get siteOptions(): Array<ISiteLookup> { return Utils.siteOptionsFilter(this.siteList, ""); }

        showDialogue: boolean = false;
        dialogueTitle: string = "";
        briefing: Briefing = new Briefing();

        get isNew(): boolean { return Utils.isEmptyId(this.briefing.id); }

        //
        // -- methods
        //

        add(siteID: string): void {
            this.reset();
            this.briefing.siteID = siteID;
            this.dialogueTitle = "Add Site Induction";
            this.showDialogue = true;
        }

        async edit(id: string): Promise<void> {
            this.reset();
            this.dialogueTitle = "Edit Site Induction";
            const briefingData: IBriefing = await ApiClient.get(`api/briefing/Load?id=${id}`);
            this.briefing.update(briefingData);
            this.showDialogue = true;
        }

        reset(): void {
            Utils.resetObject(this.briefing);
            this.briefingForm?.resetValidation();
        }

        async save(): Promise<void> {
            if (!this.briefingForm.validate()) {
                toastr.warning("Please fix highlighted issues", "Cannot Save");
                return;
            }
            const response: ISaveResponse = await ApiClient.post("/api/briefing/save", this.briefing, "briefing-save");
            if(this.briefing.isNew) this.briefing.id = response.newID;
            toastr.success("Saved");
            this.$emit("saved", this.briefing);
            this.showDialogue = false;
        }

        confirmDelete(): void {
            const dialog: ConfirmDialogue = this.$refs.deleteDialogue as ConfirmDialogue;
            dialog.show();
        }

        async doDelete(): Promise<void> {
            await ApiClient.post("/api/briefing/delete", this.briefing, "briefing-delete");
            toastr.warning(this.briefing.name, "Deleted");
            this.$emit("deleted");
            this.showDialogue = false;
        }
    }
